import React from 'react';
import { DndContext, closestCorners, DragOverlay, defaultDropAnimationSideEffects } from '@dnd-kit/core';
import { Typography } from 'antd';
import { DragOutlined } from '@ant-design/icons';
import { Column } from '..';

const dropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: { active: { opacity: '0.8' } },
  }),
};

export default function ColumnsGrid({
  sensors,
  updatedColumns,
  filteredTasks,
  activeTask,
  searchTerm,
  handlers: { onDragStart, onDragOver, onDragEnd, onDragCancel, onViewDetails, onToggleDone },
}) {
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCorners}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
      onDragCancel={onDragCancel}
    >
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '16px',
        alignItems: 'start',
        flex: 1,
        minWidth: 0
      }}>
        {updatedColumns.map(column => (
          <Column
            key={column.id}
            column={column}
            tasks={filteredTasks}
            onViewDetails={onViewDetails}
            onToggleDone={onToggleDone}
            activeTask={activeTask}
            searchTerm={searchTerm}
          />
        ))}
      </div>

      <DragOverlay dropAnimation={dropAnimation}>
        {activeTask ? (
          <div style={{
            background: 'white',
            border: '2px solid #1890ff',
            borderRadius: '6px',
            padding: '8px',
            boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)',
            transform: 'rotate(2deg)',
            opacity: 0.9,
            cursor: 'grabbing',
            maxWidth: '240px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontWeight: '600',
              color: '#1890ff',
              fontSize: '12px'
            }}>
              <DragOutlined />
              {activeTask.content}
            </div>
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>
  );
}


